import { render } from "./password-set.vue?vue&type=template&id=2b7502e6"
import script from "./password-set.vue?vue&type=script&lang=js"
export * from "./password-set.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__